import { Text } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet } from 'react-native'
import { TextProps } from '../../../redux/theme/types'

export const Label: FunctionComponent<TextProps> = ({ style, ...props }) => <Text style={[styles.content, style]} {...props} />

const styles = StyleSheet.create({
  content: {
    flex: 1,
    flexDirection: 'row',
  },
})
